import React from 'react';
import { useSelector } from 'react-redux';
import { getGameContextState } from './store/selectors/gameContextSelector';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import GameContext from './GameContext';
import gameContext from './store/reducers/gameContext';
import { alternateRoutes as TopPerformerRoutes } from '../TopPerformers/containers/TopPerformersDataContainer';
import { routes as TeamSummaryMatchupRoutes } from '../TeamSummaryMatchup/TeamSummaryMatchupDataContainer';
import { routes as MediaLinkRoutesRoutes } from '../MediaLinks/MediaLinksDataContainer';
import { routes as BroadcasterRoutes } from '../Broadcasters/containers/BroadcastersDataContainer';
import { routes as TicketButtonRoutes } from '../TicketsButton/BuyTicketsButtonDataContainer';
import topPerformersReducer from '../TopPerformers/store/reducers/topPerformers';

initContainerData.register({
    datasources: {
        topPerformers: topPerformersReducer
    },
    reducers: {
        gameContext
    }
});

const routes = [{
    path: '/',
    exact: false,
    routes: [
        ...TeamSummaryMatchupRoutes,
        ...MediaLinkRoutesRoutes,
        ...BroadcasterRoutes,
        ...TopPerformerRoutes,
        ...TicketButtonRoutes
    ]
}];

const GameContextDataContainer = (props) => {
    const gameContextState = useSelector(getGameContextState);
    return (
        <GameContext
            {...gameContextState}
            { ...props }
        />

    );
};

GameContextDataContainer.propTypes = {
};

export default GameContextDataContainer;

export { routes };
